export default __webpack_public_path__ + "static/media/gruppenbus_karte_anfahrt2.0adb8479.jpg";